import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function QRCodeSection() {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-primary to-primary-dark rounded-3xl overflow-hidden shadow-warm-2xl">
          <div className="grid lg:grid-cols-2 gap-12 items-center p-8 md:p-12 lg:p-16">
            <div className="text-white">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-6">
                Quick Download<br />
                with QR Code
              </h2>
              <p className="text-lg text-primary-foreground/90 mb-8">
                Scan the QR code with your phone camera to instantly download KissaFM. No app store navigation needed!
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">1</span>
                  </div>
                  <div>
                    <h4 className="font-heading font-bold mb-1">Open Camera App</h4>
                    <p className="text-primary-foreground/80 text-sm">
                      Use your phone's default camera application
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">2</span>
                  </div>
                  <div>
                    <h4 className="font-heading font-bold mb-1">Scan QR Code</h4>
                    <p className="text-primary-foreground/80 text-sm">
                      Point your camera at the QR code on the right
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">3</span>
                  </div>
                  <div>
                    <h4 className="font-heading font-bold mb-1">Download & Enjoy</h4>
                    <p className="text-primary-foreground/80 text-sm">
                      Tap the notification to install and start listening
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center space-x-4 text-sm">
                <Icon name="ShieldCheckIcon" size={20} variant="solid" />
                <span>100% Safe & Secure Download</span>
              </div>
            </div>

            <div className="flex justify-center lg:justify-end">
              <div className="bg-white p-8 rounded-3xl shadow-warm-2xl">
                <div className="w-64 h-64 bg-gray-100 rounded-2xl flex items-center justify-center mb-6">
                  <AppImage
                    src="https://img.rocket.new/generatedImages/rocket_gen_img_13dd1b535-1767564151092.png"
                    alt="QR code for downloading KissaFM mobile application with app logo in center"
                    className="w-full h-full object-contain" />

                </div>
                <div className="text-center">
                  <p className="text-text-primary font-semibold mb-2">
                    Scan to Download
                  </p>
                  <p className="text-text-secondary text-sm">
                    Available on Android & iOS
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}